import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'reactstrap';

import questionBankIcon from '../../../assets/img/question_bank/question_icon_blue.svg';
import GMATCalculator from '../../../common/Calculator/GMATCalculator';
import ComponentHeader from '../../../common/ComponentHeader';
import CustomButton from '../../../common/CustomButton';
import { countStatements, renderHTMLContent } from '../../../common/function';
import { messages } from '../../../common/messages';
import FlashCard from '../../../components/FlashCard';
import ValidateSaveReportIcon from '../../../views/Common/ValidateSaveReportIcon';
import CustomCard from '../../QuestionBank/CustomCard';
import CustomCardBody from '../../QuestionBank/CustomCardBody';
import CustomCardHeader from '../../QuestionBank/CustomCardHeader';
import LoaderWrapper from '../../QuestionBank/LoaderWrapper';
import ReportComponent from '../../ReportComponent';
import { examNames, QUESTION_TYPE } from '../../../common/constant';
import { getUserSelectedChoices } from './utils/quizUtils';
import { multiSourceConfig } from './utils/quizConfigs';

export default class MultiSourceTab extends Component {
  static contextTypes = {
    router: PropTypes.object,
  };
  constructor(props) {
    super(props);
    this.state = {
      isLoading: true,
      isUserSubscribed: false,
      currentIndex: 0,
      currentQuestion: {},
      questionData: [],
      selectedAnswer1: '',
      selectedAnswer2: '',
      validated: false,
      isUserSelectedChoice: false,
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      saveTooltipTitle: `${messages.SAVE_ITEM_DESCRIPTION}`,
      questionRatingTitle: messages.RATING_THIS_QUESTION,
      isFlashCardHidden: true,
      isReportCardHidden: true,
      showCalculator: false,
      isError: false,
    };
    this.childRef = null;
    this.setChildRef = (element) => {
      this.childRef = element;
    };
  }
  async componentDidMount() {
    await this.handleSetCurrentQuestion();
  }
  async componentDidUpdate(prevProps) {
    const { params } = this.props;
    if (params && Object.keys(params).length > 0 && prevProps.params !== params) {
      this.handleSetCurrentQuestion();
    }
  }
  setUserSelectedChoices = async () => {
    const { params, questionIds, questionTypes, apiServices, onHandleSetTimer } = this.props;
    const { quiz_id, offset } = params;
    const currentQuestionId = questionIds[offset];
    const currentQuestionType = questionTypes[offset];
    const { currentQuestion } = this.state;
    const payload = {
      quiz_id,
      question_id: currentQuestionId,
      type: currentQuestionType,
    };
    const response = await apiServices.checkUserSelectedAnswer(payload);
    const received = response.question_recived || {};

    const { selectedOptions, extraState } = getUserSelectedChoices({
      question: currentQuestion,
      stat: received,
      config: multiSourceConfig,
    });
    if (selectedOptions && Object.keys(selectedOptions).length > 0) {
      this.setState({
        selectedOptions,
        ...selectedOptions,
        ...extraState,
      });
    } else {
      this.setState({
        ...multiSourceConfig.extractExtraState(selectedOptions, received),
        ...selectedOptions,
        selectedOptions,
      });
    }

    onHandleSetTimer(!response.question_recived, !!response.question_recived);
  };

  handleSetCurrentQuestion = async () => {
    const { params, questionIds, questionTypes, apiServices } = this.props;
    const { quiz_id, offset } = params;
    const currentQuestionId = questionIds[offset];
    const currentQuestionType = questionTypes[offset];

    const payload = {
      quiz_id,
      question_id: currentQuestionId,
      type: currentQuestionType,
    };
    const response = await apiServices.getQuestionById(payload);
    this.setState(
      {
        // isLoading: false,
        currentIndex: parseInt(offset, 10) || 0,
        currentQuestion: response.questionsbyid || {},
      },
      () => {
        this.getSavedQuestion(currentQuestionId);
        this.setUserSelectedChoices();
      },
    );
  };

  handleSaveQuestion = async () => {
    const { currentQuestion, bookmarkCSS } = this.state;
    const {
      apiServices,
      questionType: type,
      params: { readingid: reading_id, question_id, reading: topic_name },
    } = this.props;

    const isSaved = bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark';

    const payload = {
      question_id: currentQuestion.id,
      type,
      topic_name,
      reading_id,
    };
    const endpoint = isSaved ? apiServices.deleteSavedQuestion : apiServices.saveQuestion;
    const response = await endpoint(payload);

    if (isSaved && this.childRef) {
      this.childRef.deleteFlash();
    }

    this.setState({
      bookmarkCSS: isSaved
        ? 'fa fa-bookmark-o mark-action-btn-bookmark'
        : 'fa fa-bookmark mark-action-btn-bookmark',
      bookmarkColor: isSaved ? '' : 'rgb(54, 141, 84)',
      saveTooltipTitle: isSaved ? messages.SAVE_ITEM_DESCRIPTION : messages.QUESTION_SAVED,
      isFlashCardHidden: isSaved,
    });
  };

  getSavedQuestion = async (questionId) => {
    const { apiServices, params, questionType: type } = this.props;
    const { chapterid: chapter_id } = params;

    const payload = {
      question_id: questionId,
      chapter_id,
      type,
    };
    const response = await apiServices.fetchSavedQuestion(payload);
    this.setState({
      isFlashCardHidden: !response.success,
      ...(response.success && {
        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
        bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
        bookmarkColor: 'rgb(54, 141, 84)',
        saveTooltipTitle: `${messages.QUESTION_SAVED}`,
        isFlashCardHidden: false,
      }),
    });
  };

  resetStates = () => {
    this.setState({
      validated: false,
      isLoading: true,
      selectedAnswer1: '',
      isError: false,
      selectedAnswer2: '',
      selectedOptions: {},
      isUserSelectedChoice: false,
      isReportCardHidden: true,
      isFlashCardHidden: true,
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      bookmarkColor: '',
      saveTooltipTitle: `${messages.SAVE_ITEM_DESCRIPTION}`,
    });
  };

  getPreviousQuestion = async () => {
    const { currentIndex } = this.state;
    const { handleChangeParams } = this.props;
    if (currentIndex > 0) {
      handleChangeParams(currentIndex - 1);
      await this.resetStates();
      await this.handleSetCurrentQuestion();
    }
  };

  getNextQuestion = async () => {
    const { currentIndex } = this.state;
    const { questionIds, handleChangeParams } = this.props;
    const nextIndex = currentIndex + 1;
    if (nextIndex < Object.keys(questionIds).length) {
      handleChangeParams(currentIndex + 1);
      await this.resetStates();
      await this.handleSetCurrentQuestion();
    }
  };

  handleSelect = (type, value) => {
    this.setState({ [type]: value });
  };

  handleValidate = async (isSaveAttemptStats = true) => {
    const { selectedOptions, currentQuestion } = this.state;
    const {
      apiServices,
      questionType: type,
      params: { quiz_id },
      onHandleSetTimer,
    } = this.props;

    // Count total statements dynamically (e.g. statement1, statement2…)
    const totalStatements = countStatements(currentQuestion);

    const selectedCount = Object.values(selectedOptions).filter(Boolean).length;
    // We cannot remove the `is_single_choice` condition because validation rules differ:
    // - For single choice questions → the user must select exactly ONE option.
    // - For multi-statement questions → the user must provide an answer for EACH available statement.
    // Without this condition, both question types would be validated the same way, which would break correctness.
    const isValidated = currentQuestion.is_single_choice ? selectedCount === 1 : selectedCount === totalStatements;
    if (!isValidated) {
      this.setState({ isError: true });
      return;
    }
    const isCorrect = Object.keys(selectedOptions).every((key) => {
      if (currentQuestion[key] !== undefined && currentQuestion[key] !== null) {
        return String(currentQuestion[key]).trim() === String(selectedOptions[key] || '').trim();
      }
      return false;
    });

    const selectedChoice = JSON.stringify(selectedOptions);

    onHandleSetTimer(false, true);

    this.setState((prevState) => ({
      validated: true,
      isUserSelectedChoice: isCorrect,
    }));
    const payload = {
      question_id: currentQuestion.id,
      right_answer: isCorrect ? 1 : 0,
      answer: isCorrect ? 1 : 0,
      quiz_id,
      selected_choice: selectedChoice,
      type,
    };
    if (isSaveAttemptStats) {
      await apiServices.saveAttemptStats(payload);
      await apiServices.saveQuizAnswer(payload);
    }
  };

  handleChoicesSelect = (event) => {
    const { name, value } = event.target;
    const { currentQuestion } = this.state;

    this.setState((prevState) => {
      let selectedOptions;
      if (currentQuestion.is_single_choice) {
        // Only keep the current selection for single choice
        selectedOptions = { [name]: value };
      } else {
        // Keep previous selections for multi choice
        selectedOptions = {
          ...prevState.selectedOptions,
          [name]: value,
        };
      }
      return {
        selectedOptions,
        isError: false,
      };
    });
  };
  renderOptions = () => {
    const { validated, currentQuestion, selectedOptions = {} } = this.state;

    // Get entries like { key: "statement1", value: "Some statement" }
    const optionEntries = Object.entries(currentQuestion)
      .filter(([key]) => key.startsWith('statement'))
      .map(([key, value]) => ({ key, value }));

    return optionEntries.map((optionValue, index) => {
      const optionKey = optionValue.key;
      const answerKey = optionKey.replace('statement', 'answer');
      const correctAnswer = currentQuestion[answerKey];
      const choicesStatement = currentQuestion.is_single_choice ? ['yes'] : ['yes', 'no'];
      return (
        optionValue.value && (
          <tr key={optionKey}>
            {choicesStatement.map((choiceValue) => {
              const isSelectedChoice = selectedOptions[answerKey] === choiceValue;

              // Apply validation class if validated is true and choice is selected
              let validationClass = '';
              const isCorrect = String(choiceValue).trim() === String(correctAnswer).trim();
              if (validated && isSelectedChoice) {
                validationClass = isCorrect ? 'accent-success' : 'accent-faliure';
              }
              const isShowCorrectChoices = validated && !isSelectedChoice && isCorrect;
              const ariaLabel = `${choiceValue} — ${optionValue.value}`;
              return (
                <td className={`p-10px ${validationClass}`} key={`${answerKey}-${choiceValue}`}>
                  {isShowCorrectChoices ? (
                    <input
                      type='radio'
                      name={`correct${index}`}
                      aria-label={`Correct answer: ${ariaLabel}`}
                      className='accent-success'
                      checked
                      readOnly
                    />
                  ) : (
                    <input
                      type='radio'
                      name={answerKey}
                      aria-label={ariaLabel}
                      className='border-solid'
                      checked={isSelectedChoice}
                      disabled={!validationClass && validated}
                      value={choiceValue}
                      onChange={this.handleChoicesSelect}
                    />
                  )}
                </td>
              );
            })}
            <td className='p-10px text-left'>{optionValue.value}</td>
          </tr>
        )
      );
    });
  };

  reportCardToggle = () => {
    this.setState((prevState) => ({
      isReportCardHidden: !prevState.isReportCardHidden,
    }));
  };

  /**
   * Handles tab change events by updating the display of tab content and the active state of tab links.
   * This function is used as-is from older code and has not been modified.
   */
  onHandleTabChange = (event, tabName) => {
    const tabContent = document.getElementsByClassName('tabcontent');
    const tabLinks = document.getElementsByClassName('tablinks');
    const value = event.target.value;
    for (let i = 0; i < tabContent.length; i++) {
      tabContent[i].style.display = 'none';
    }
    for (let i = 0; i < tabLinks.length; i++) {
      if (tabLinks[i].value === tabName) {
        tabLinks[i].className += ' active';
      } else {
        tabLinks[i].classList.remove('active');
      }
    }
    document.getElementById(tabName).style.display = 'block';
  };

  clickHandler = (event) => {
    this.onHandleTabChange(event, event.target.value.trim());
  };
  render() {
    const {
      isLoading,
      questionData,
      currentIndex,
      currentQuestion,
      isUserSelectedChoice,
      validated,
      saveTooltipTitle,
      bookmarkCSS,
      bookmarkColor,
      isFlashCardHidden,
      isReportCardHidden,
      showCalculator,
      isError,
    } = this.state;
    const { apiServices, params, redirectToResults, questionType, questionIds, examName } = this.props;
    // Quiz routes don't expose question_id / readingid / reading in URL params;
    // pull report fields from currentQuestion + questionType so /reportQuestion
    // gets real values instead of undefined → NULL rows in *_ques_reports.
    const { offset, quiz_id: quizId } = params;
    const question_id = currentQuestion && currentQuestion.id;
    const reading_id = currentQuestion && currentQuestion['gmat_focus_reading.id'];
    const topic_name = currentQuestion && currentQuestion['gmat_focus_reading.name'];
    const type = questionType;

    return (
      <div>
        <ComponentHeader title={`${messages.QUIZ_ID}: ${quizId}`}>
          <div>
            <CustomButton
              className='mr-1 calc-btn'
              onClick={() =>
                this.setState({
                  showCalculator: true,
                })
              }
            >
              {messages.OPEN_CALCULATOR}
            </CustomButton>
            <CustomButton className='mr-1' onClick={() => redirectToResults()}>
              {messages.BACK_TO_SUMMARY}
            </CustomButton>
          </div>
        </ComponentHeader>

        <LoaderWrapper isLoading={isLoading}>
          {currentQuestion && Object.keys(currentQuestion).length ? (
            <CustomCard>
              <CustomCardHeader
                headingText={`(Q. ${parseInt(offset, 10) + 1})`}
                headerImage={questionBankIcon}
                arrayLength={Object.keys(questionIds).length}
                showPreviousButton
                showNextButton
                disabledPreviousButton={currentIndex < 1}
                disabledNextButton={currentIndex >= Object.keys(questionIds).length - 1}
                getPreviousQuestion={this.getPreviousQuestion}
                getNextQuestion={this.getNextQuestion}
              />
              <CustomCardBody>
                <Row>
                  <Col
                    xs={5}
                    sm={12}
                    lg={5}
                    className='mb-0 calc_height_GMAT overflow-y-auto mb-sm-1 question-view'
                  >
                    {renderHTMLContent(currentQuestion.question_tab, 'div', '', {
                      onClick: this.clickHandler,
                    })}
                  </Col>
                  <Col xs={5} sm={12} lg={5} className='text-center font-16px'>
                    {renderHTMLContent(currentQuestion.question, 'div', 'text-left')}
                    <table className='text-center  margin_bottom_30 mt-3'>
                      <thead>
                        {!currentQuestion.is_single_choice && (
                          <tr>
                            <th className='p-10px'>{currentQuestion.choice_a}</th>
                            <th className='p-10px'>{currentQuestion.choice_b}</th>
                            <th className='p-10px' />
                          </tr>
                        )}
                      </thead>
                      <tbody>{this.renderOptions()}</tbody>
                    </table>
                    {isError && (
                      <Col sm={12} md={12} lg={12} className='text-danger text-left  mb-0 pb-0'>
                        {messages.SELECT_OPTION_ERROR}
                      </Col>
                    )}
                    <div className='text-center mt-3 d-flex'>
                      {/* // TODO: Optimize this code in the future and remove the CSS states from component state */}
                      <ValidateSaveReportIcon
                        isQue={true}
                        showResult={validated}
                        _getResult={this.handleValidate}
                        _saveQuestion={this.handleSaveQuestion}
                        _displayReportForm={this.reportCardToggle}
                        all_questions={questionData}
                        save_text={saveTooltipTitle}
                        bookmarkCSS={bookmarkCSS}
                        bookmarkColor={bookmarkColor}
                      />
                    </div>
                  </Col>
                  <Col xs={2} sm={12} lg={2} className='text-center'>
                    {this.props.children}
                  </Col>
                </Row>
              </CustomCardBody>
            </CustomCard>
          ) : (
            <h1 className='text-center pt-3 pb-3'>{messages.NO_DATA_FOUND}</h1>
          )}
        </LoaderWrapper>

        {validated && (
          <Row>
            <Col>
              <CustomCard className='font-lusitana font-16px'>
                <CustomCardHeader
                  headingText={isUserSelectedChoice ? messages.CORRECT : messages.INCORRECT}
                  className={`text-uppercase ${isUserSelectedChoice ? 'text_success' : 'text_failure'}`}
                />
                <CustomCardBody>
                  {renderHTMLContent(currentQuestion.explanation, 'span')}
                </CustomCardBody>
              </CustomCard>
            </Col>
          </Row>
        )}
        <FlashCard
          item={{ id: currentQuestion && currentQuestion.id }}
          type={QUESTION_TYPE.QUESTION}
          question_type={questionType}
          isFlashCardHidden={isFlashCardHidden}
          ref={this.setChildRef}
          exam={examName}
        />
        <ReportComponent
          visible={!isReportCardHidden}
          apiServices={apiServices}
          payload={{
            question_id,
            type,
            topic_name,
            reading_id,
          }}
        />
        <GMATCalculator
          show={showCalculator}
          closeModal={() => this.setState({ showCalculator: false })}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/Components-2025/IR/Quiz/MultiSourceTab.jsx